import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import ZoomGraphQLReaderForm from '../forms/zoom-graphql-reader-form';
import { zoomGraphQLReaderValidationSchema } from '../schema/zoomGraphQLReader.js';

export default function ZoomGraphQLReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Zoom GraphQL Reader Node Details',
        altText: 'Zoom GraphQL Reader Node',
        defaultLabel: 'Zoom GraphQL Reader Node',
      }}
    >
      <CommonNode
        FormComponent={ZoomGraphQLReaderForm}
        schemaResolver={zoomGraphQLReaderValidationSchema}
      />
    </NodeProvider>
  );
}
